<template>
  <div
    @click="$emit('updateCurrentDay', date)"
    class="datepicker-date"
    :class="{'is-today': isToday, 'is-current-month' : isCurrentMonth, 'is-disabled' : !isCurrentMonth}"
    v-tooltip="tooltipContent">
    <button
      class="date-item"
      :class="{}">
      {{ day }}
    </button>

    <div class="datepicker-events">
      <!-- <a href="#" class="datepicker-event" v-if="totalEvents > 0">
        <span class="datepicker-event-dot is-warning"></span>
      </a> -->
      <a
        href="#"
        class="datepicker-event"
        v-if="todayRdvs.length">
        <span class="datepicker-event-dot is-rdv"></span>
      </a>
      <a
        href="#"
        class="datepicker-event"
        v-if="todayOptions.length">
        <span class="datepicker-event-dot is-success"></span>
      </a>
      <a
        href="#"
        class="datepicker-event"
        v-if="todayReminders.length">
        <span class="datepicker-event-dot is-danger"></span>
      </a>
      <!-- <a href="#" class="datepicker-event" v-if="totalEvents > 4">
        <span class="datepicker-event-dot is-draft"></span>
      </a> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { concat } from 'lodash'

export default {
  name: 'CalendarDayItemCompact',
  props: {
    date: {
      type: Object,
      required: true
    },
    options: Array,
    rdvs: Array,
    reminders: Array,
    currentMonth: Object,
    myRdv: Boolean
  },
  data () {
    return {}
  },
  computed: {
    day () {
      return this.date.format('DD')
    },
    month () {
      return this.date.format('MM')
    },
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    isCurrentMonth () {
      return this.currentMonth.format('MM') === this.date.format('MM')
    },
    isPast () {
      return this.date.format('YYYYMMDD') < moment().format('YYYYMMDD')
    },
    totalEvents () {
      return concat(this.todayRdvs, this.todayReminders, this.todayOptions)
    },
    todayOptions () {
      let result = []
      for (let option of this.options) {
        if (moment(option.end_date).isSame(this.date, 'day')) result.push(option)
      }
      return result
    },
    todayRdvs () {
      let result = []
      for (let rdv of this.rdvs) {
        if (moment(rdv.date).isSame(this.date, 'day')) result.push(rdv)
      }
      return result
    },
    todayReminders () {
      let result = []
      for (let reminder of this.reminders) {
        if (moment(reminder.date).isSame(this.date, 'day')) result.push(reminder)
      }
      return result
    },
    tooltipContent () {
      if (this.totalEvents.length === 0) {
        return null
      }
      let str = []
      if (this.todayReminders.length === 1) {
        str.push(`${this.todayReminders.length} Rappel`)
      } else if (this.todayReminders.length > 1) {
        str.push(`${this.todayReminders.length} Rappels`)
      }
      if (this.todayRdvs.length >= 1) {
        str.push(`${this.todayRdvs.length} Rendez-vous`)
      }
      if (this.todayOptions.length === 1) {
        str.push(`${this.todayOptions.length} Option`)
      } else if (this.todayOptions.length > 1) {
        str.push(`${this.todayOptions.length} Options`)
      }
      return {
        content: str.join(', '),
        placement: 'top',
        classes: ['is-dark is-size-7'],
        offset: 5,
        delay: {
          show: 0,
          hide: 200
        }
      }
    }
  },
  methods: {}
}
</script>
